module.exports = __webpack_public_path__ + "img/avatar7.bad1affc.png";